import { Icon, Checkbox } from 'semantic-ui-react';
import { useShare } from '../../context/ShareContext';
import './LookbookCard.css';

const LookbookCard = ({
    lookbook,
    onClick,
    onEdit,
    onDelete,
    isBulkMode = false,
    isSelected = false,
    isDefault = false,
    isHorizontal = false
}) => {
    const { name, previewImages = [], itemCount = 0 } = lookbook;
    const { openShare } = useShare();

    // Get preview images (up to 4)
    const previews = previewImages.slice(0, 4);

    const handleShareClick = (e) => {
        e.stopPropagation();
        openShare({
            sourceType: 'lookbook',
            lookbookId: lookbook.id,
            title: name,
            itemCount,
            previewImages
        });
    };

    return (
        <div
            className={`lookbook-card ${isSelected ? 'selected' : ''} ${isHorizontal ? 'horizontal' : ''}`}
            onClick={onClick}
        >
            {/* Selection checkbox in bulk mode (not for default) */}
            {isBulkMode && !isDefault && (
                <div className="bulk-checkbox-wrapper" onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        checked={isSelected}
                        label=""
                        onChange={(e) => {
                            e.stopPropagation();
                            onClick && onClick(lookbook);
                        }}
                    />
                </div>
            )}

            {/* Delete button - shows on hover for non-default lookbooks */}
            {!isBulkMode && !isDefault && onDelete && (
                <div
                    className="card-delete-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete(lookbook);
                    }}
                    title="Delete Lookbook"
                >
                    <Icon name="close" color="red" />
                </div>
            )}

            {/* Preview grid */}
            <div className={`preview-grid items-${Math.min(previews.length, 4)}`}>
                {previews.length > 0 ? (
                    previews.map((url, index) => (
                        <div key={index} className="preview-cell">
                            <img src={url} alt="" className="preview-image" />
                        </div>
                    ))
                ) : (
                    <div className="empty-preview">
                        <Icon name="images outline" />
                    </div>
                )}
            </div>

            {/* Card footer */}
            <div className="card-footer">
                <span className="lookbook-name" title={name}>
                    {name}
                </span>
                {!isBulkMode && (
                    <div className="card-footer-actions">
                        <button
                            className="lookbook-share-btn"
                            onClick={handleShareClick}
                            title={`Share ${name}`}
                        >
                            <Icon name="share alternate" />
                        </button>
                        {onEdit && !isDefault && (
                            <button
                                className="edit-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onEdit(lookbook);
                                }}
                                title="Rename"
                            >
                                <Icon name="edit" />
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default LookbookCard;
